import DataTable, { DataTableDefault } from './components';
import reducer, { createReducer } from './reducers';
import * as actions from './actions';

export {
    DataTable as default,
    DataTableDefault,
    actions,
    reducer,
    createReducer
};



// WEBPACK FOOTER //
// ./src/js/modules/DataTable/index.js